import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItemContent,[_c(VListItemTitle,{domProps:{"textContent":_vm._s(_vm.indent(_vm.process))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }